module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.books) ? _c('section', [_c('div', {
    staticClass: "cart"
  }, [_c('Cart')], 1), _vm._v(" "), _c('BookFilter', {
    on: {
      "set-filter": _vm.setFilter
    }
  }), _vm._v(" "), _c('h2', [_vm._v("We have " + _vm._s(_vm.books.length) + " Books")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.isCreateMode = true
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('ul', _vm._l((_vm.booksToShow), function(currBook) {
    return _c('book-preview', {
      key: currBook.id,
      attrs: {
        "book": currBook
      },
      on: {
        "edit": function($event) {
          _vm.editBook(currBook)
        },
        "delete": function($event) {
          _vm.deleteBook(currBook)
        },
        "add-to-cart": function($event) {
          _vm.addToCart(currBook)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectBook(currBook)
        }
      }
    })
  })), _vm._v(" "), (_vm.selectedBook) ? _c('BookDetails', {
    attrs: {
      "book": _vm.selectedBook
    },
    on: {
      "close": _vm.resetSelected,
      "next": _vm.selectNext
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editedBook || _vm.isCreateMode) ? _c('BookEdit', {
    attrs: {
      "book": _vm.editedBook
    },
    on: {
      "save": _vm.saveBook,
      "delete": function($event) {
        _vm.editedBook = null;
        _vm.isCreateMode = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114e1a89","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/BookList.vue
// module id = 277
// module chunks = 1